import {Values} from "@wix/devzai-utils-common";

export const RestfulApiHttpMethod = {
    Post: 'POST',
    Get: 'GET'
} as const;

export type RestfulApiHttpMethod = Values<typeof RestfulApiHttpMethod>;